import { Injectable } from '@angular/core';
import {
  AdministratorFacade,
  Helper,
  abbreviateCountryStr,
  getRolesAndPermission,
} from '@piqet-angular/data';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateDataGridService {
  event: any;
  statePayload: any;

  editStateData = new Subject<[any, any, any]>();
  stateObservable$ = this.editStateData.asObservable();

  deleteStateData = new Subject<[any, any, any]>();
  stateDeleteObservable$ = this.deleteStateData.asObservable();

  constructor(private swalService: SwalService) {}

  getStateColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country name',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      lockVisible: true,
      cellRenderer: (params: any, pathName: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${abbreviateCountryStr(params.data?.countryName)}`;
        cellElement.style.cursor = 'pointer';
        cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          if (
            params.columnApi.columnModel.columnDefs[
              params.columnApi.columnModel.columnDefs.length - 1
            ].cellRendererParams?.showEdit
          )
            this.editStateData.next([
              params.data.id,
              'Review new state',
              location.href.split('/')[6],
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'State name',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      // sort:'asc',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        editData: (data: any, pathName: any) => {
          this.editStateData.next([data.id, 'Review new state', pathName]);
        },
        deleteData: (data: any, pathName: any) => {
          this.deleteStateDataConfirmation(data.id, '/State/DeleteState?id', pathName);
        },
      },
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(rolesModuleName.AdvancedState, mainModuleName.advancedModule);
  };

  deleteStateDataConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteStateData.next([data, customType, pathName]);
      }
    });
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getStateColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.statePayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'name',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
